import React from 'react';
import { FAQSection } from '../ProductInfoPanel/ProductInfoPanel';



interface FAQContainerProps {
 faqs:any[]
  toggleSection: (index: number) => void;
  openSections: { [key: number]: boolean };
}

const RefillFAQ: React.FC<FAQContainerProps> = ({ faqs, toggleSection, openSections }) => {
  return (
    <div className='bg-white mt-[-10px]'>
      <section className="relative min-h-auto w-full mb-0">
        <div className="md:relative gap-10  flex flex-col items-center 
        justify-center w-full">
          <div className="mt-[-5px] md:px-60 w-full">
            <div className="bg-white rounded-xl relative w-full 
          px-10 py-20 text-[#005D6E]">
              <div className="w-full">
                
                <div className="flex justify-between items-start">
                  <div className="flex gap-4 items-center justify-start ">
                    <div className="faq-section">
                      <FAQSection sections={faqs || []} toggleSection={toggleSection} openSections={openSections} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefillFAQ;
